<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid v-if="notifications.length > 0">
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3>Tất cả thông báo</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            @click="deleteDialog = true"
            dark
            v-show="notifications.length > 0"
          >Xóa tất cả</v-btn>
        </v-toolbar>
        <v-flex lg12>
          <notification-table :datasource="notifications"/>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-else>
      <blank
        :src="`/static/icons/blank/news.png`"
        :firstLine="`Chưa có dữ liệu`"
        :secondLine="`Các cảnh báo từ xe sẽ được hiển thị tại đây`"
        :width="360"
      />
    </div>
    <div class="text-xs-center">
      <v-dialog v-model="deleteDialog" width="360">
        <v-card>
          <v-card-title class="headline">Xóa tất cả thông báo?</v-card-title>
          <v-card-text>
            <span>Thao tác này sẽ không thể phục hồi, bạn có chắc chắn muốn xóa ?</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="deleteDialog = false">Hủy</v-btn>
            <v-btn color="red" flat="flat" :loading="isLoading" @click="deleteSubmit()">Xóa</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import NotificationTable from './components/List';
import Blank from '@/components/Blank';

export default {
  components: {
    NotificationTable,
    Blank
  },
  data () {
    return {
      deleteDialog: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['notifications']),
    notificationIds () {
      let ids = [];
      this.notifications.map(a => {
        let id = a.id;
        ids.push(id);
        return 0;
      });
      return ids;
    }
  },
  methods: {
    ...mapActions(['deleteNotifications']),
    ...mapMutations(['SET_NOTIFICATIONS']),
    deleteSubmit () {
      this.isLoading = true;
      this.deleteNotifications({ ids: this.notificationIds })
        .then(_ => {
          this.isLoading = false;
          this.deleteDialog = false;
          this.SET_NOTIFICATIONS([]);
          window.getApp.showMessage('Đã xóa tất cả thông báo');
        })
        .catch(_ => {
          this.isLoading = false;
          window.getApp.showMessage('Có lỗi xảy ra, vui lòng thử lại', 'error');
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/notification/index.vue